@import '../../scss/index';

:host {
  display: block;

  .limit-stretch {
    @include limit-stretch();
  }

  .preview-badge {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    background-color: $pds-theme-light-notification-error;
    z-index: 9999;
    padding: 0 p-px-to-rem(2px);
  }

  .main-content {
    width: 20px;

    &:focus {
      outline-style: none;
    }
  }

  .screenreader-only {
    position: absolute;
    width: 1px;
    height: 1px;
    white-space: nowrap;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
  }
}
